<div class="cp-radio-container" [formGroup]="formControl" [hidden]="isHidden">
    <se-floating-label *ngIf="control.isWithLabel"
                       [tooltip]="( control.name | translate )"
                       class="control-label">
        {{ control.name | translate }}
    </se-floating-label>

    <mat-radio-group
        #rGroup
        class="radio-group"
        [class.is-with-label]="control.isWithLabel"
        [formControlName]="control.id"
        [ngClass]="control.controlType === controlType.HorizontalRadio ? 'horizontal' : 'vertical'"
    >
        <mat-radio-button
            *ngFor="let button of control.buttons; index as i; trackBy: getButtonId"
            class="radio-button"
            radioGroup="rGroup"
            [value]="i"
            (focusin)="onFocus()"
    >
            {{ button.title }}
        </mat-radio-button>
    </mat-radio-group>
</div>
